import drawLabel from './drawLabel'
import drawLabelV2 from './drawLabelV2'
import mergeColLabels from './mergeColLabels'
import mergeRowLabels from './mergeRowLabels'

const makeImageLabels = async (labelsData, isNewLabel, width = 460, height = 170, type) => {
    const drawLabelsPromise = labelsData.map(labelData => {
        const data = Object.assign({}, labelData, {
            orderId: '#' + labelData.orderId
        })

        return isNewLabel ? drawLabelV2(data) : drawLabel(data, type)
    })

    const labels = await Promise.all(drawLabelsPromise)
    const evenLabels = labels.filter((label, index) => !(index % 2))
    const oddLabels = labels.filter((label, index) => index % 2)
    const rowLabels = []

    for (let i = 0; i < evenLabels.length; i++) {
        if (oddLabels[i]) {
            const rowLabel = await mergeColLabels(evenLabels[i], oddLabels[i])
            rowLabels.push(rowLabel)
        } else {
            rowLabels.push(evenLabels[i])
        }
    }

    const labelImages = await mergeRowLabels(rowLabels, width, height)

    return labelImages
}

export default makeImageLabels
